"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBraintreeApple = void 0;
const src_1 = require("../..");
function createBraintreeApple() {
    const isMounted = !!document.getElementById('braintree-apple-express-payment');
    if (!isMounted) {
        // creating a braintree-apple payment div inside express payment container
        const braintreeDiv = document.createElement('div');
        braintreeDiv.id = 'braintree-apple-express-payment';
        braintreeDiv.className = 'braintree-apple-express-payment express-payment';
        const button = document.createElement('button');
        button.className = 'braintree-apple-pay-button';
        button.id = 'braintree-apple-pay-button';
        button.addEventListener('click', src_1.braintreeOnClickApple);
        braintreeDiv.appendChild(button);
        const container = document.getElementById('express-payment-container');
        if (!container) {
            (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.BRAINTREE_APPLE, false);
            return;
        }
        container.appendChild(braintreeDiv);
    }
    (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.BRAINTREE_APPLE, true);
}
exports.createBraintreeApple = createBraintreeApple;
